document.addEventListener("turbo:load", function () {
    document.querySelectorAll('.dropdown').forEach((element) => {
        if (element.querySelector('.dropdown-menu .active')) {
            element.querySelector('.dropdown-toggle').classList.add("active");
        }
    })
});